<template>
  <div
    v-if="show"
    class="exam-profile-details"
  >
    <template v-if="branchesRelated && branchesRelated.length && isHeadquarter">
      <div class="exam-profile-details__title">
        <div class="exam-profile-details__name">
          FILIAIS RELACIONADAS
        </div>
      </div>
      <div
        v-for="branch in branchesRelated"
        :key="branch.id_laboratory"
        class="exam-profile-details__row"
      >
        <div class="exam-profile-details__name">
          <p
            class="ellipsable branches"
            :title="branch.name_laboratory"
          >
            {{ branch.name_laboratory }}
          </p>
        </div>
      </div>

      <hr>
    </template>

    <div class="exam-profile-details__title">
      <div class="exam-profile-details__code">
        CÓD. MNEMÔNICO
      </div>
      <div class="exam-profile-details__name">
        EXAME
      </div>
      <div class="exam-profile-details__material">
        MATERIAL
      </div>
    </div>
    <div
      v-for="(exam, index) in exams"
      :key="index"
      class="exam-profile-details__row"
    >
      <div class="exam-profile-details__code">
        <p
          class="ellipsable"
          :title="exam.examCode"
        >
          {{ exam.examCode }}
        </p>
      </div>
      <div class="exam-profile-details__name">
        <p
          class="ellipsable"
          :title="exam.name"
        >
          {{ exam.name }}
        </p>
      </div>
      <div class="exam-profile-details__material">
        <p
          class="ellipsable"
          :title="exam.material"
        >
          {{ exam.material }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamProfilesDetail',
  props: {
    exams: {
      default: null,
      type: Array
    },
    branchesRelated: {
      default: null
    },
    isHeadquarter: {
      default: true,
      type: Boolean
    },
    show: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="scss">
.exam-profile-details {
  width: 100%;
  padding: 15px 20px;
  background: #f0f0f0;

  &__table {
    width: 100%;
    overflow: hidden;
  }
  &__table-head {
    text-align: left;
  }
  &__table-head {
    th {
      font-weight: bold;
      font-size: 10px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
      line-height: 14px;
      padding-bottom: 5px;
    }
  }
  &__title {
    & > div {
      font-weight: bold;
      font-size: 10px;
      line-height: 14px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
      margin-bottom: 5px;
    }
  }
  &__row {
    & > div {
      font-size: 14px;
      line-height: 26px;
      color: #4a4a4a;
    }
  }

  &__title,
  &__row {
    display: flex;
  }
  &__code {
    width: 15%;
  }
  &__name {
    width: 60%;
  }
  &__material {
    width: 25%;
  }

  hr {
    border-color: #ccc;
    border-style: solid;
    margin: 10px 0 16px;
  }

  .ellipsable {
    &.branches {
      color: #303030;
    }
  }
}
</style>
